import { render, staticRenderFns } from "./StudentInfo.vue?vue&type=template&id=3e720e13&scoped=true&"
import script from "./StudentInfo.vue?vue&type=script&lang=js&"
export * from "./StudentInfo.vue?vue&type=script&lang=js&"
import style0 from "./StudentInfo.vue?vue&type=style&index=0&id=3e720e13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e720e13",
  null
  
)

export default component.exports